import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  setAppointmentCount,
  setAppointmentsByDateList,
} from "./DispatchSlice";

export const CreateTechLeaveApi = (obj, date) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Appointment/AddTechnicianUnavailability`, obj)
      .then((res) => {
        dispatch(hideLoader());
        getAppointmentsByDate({
          startDate: date.format("YYYY-MM-DD"),
          pageNo: 1,
          pageSize: 24,
        });
        dispatch(getAppointmentCountByStatusId(date.format("YYYY-MM-DD")));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Dispatch.Notification.Leaveaddedsuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          e.status == 409 && e.response?.data?.code == "LEAVE_EXISTS"
            ? "Dispatch.Notification.Leavealreadyexists"
            : e.status == 409 && e.response?.data?.code == "APPOINTMENT_EXISTS"
            ? "Dispatch.Notification.Appointmentalreadyexists"
            : "Clients.Notification.UnexpectedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Dispatch.Notification.Anunexpectederroroccurredwhileaddingclient"
    );
    return false;
  }
};

export const deleteTechnicianLeaveById = (Id, date) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Appointment/DeleteLeaveById/${Id}`)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Dispatch.Notification.Leavedeleted"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "Dispatch.Notification.Anunexpectederroroccurredwhiledeletingleave"
    );
  }
};

export const getAppointmentsByDate = (searchParams) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest("api/Appointment/GetAppointmentsByDate", searchParams)
      .then((res) => {
        dispatch(
          setAppointmentsByDateList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch(() => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Clients.Notification.UnexpectedError"
    );
  }
};
export const getAppointmentCountByStatusId = (date) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Appointment/GetAppointmentCountByStatusId?date=${date}`)
      .then((res) => {
        dispatch(
          setAppointmentCount({
            notStarted: res?.data?.notStarted,
            inProgress: res?.data?.inProgress,
            completed: res?.data?.completed,
          })
        );
        dispatch(hideLoader());
      })
      .catch(() => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Clients.Notification.UnexpectedError"
    );
  }
};
